import { combineReducers } from "redux";
import App from "@iso/redux/app/reducer";
import Auth from "@iso/redux/auth/reducer";
import Booking from "@iso/redux/booking/reducer";
import Property from "@iso/redux/property/reducer";
import Albaran from "@iso/redux/albaran/reducer";
import Invoice from "@iso/redux/invoice/reducer";
import Serie from "@iso/redux/serie/reducer";
import Payment from "@iso/redux/payment/reducer";
import Log from "@iso/redux/log/reducer";
import Item from "@iso/redux/item/reducer";
import Feature from "@iso/redux/feature/reducer";
import City from "@iso/redux/city/reducer";
import User from "@iso/redux/user/reducer";
import ThemeSwitcher from "@iso/redux/themeSwitcher/reducer";
import LanguageSwitcher from "@iso/redux/languageSwitcher/reducer";
import Settings from "@iso/redux/settings/reducer";
import actions from './auth/actions';

// Combine all reducers.
const appReducer = combineReducers({
  Auth,
  App,
  Booking,
  Payment,
  Property,
  Log,
  Item,
  Feature,
  City,
  Albaran,
  Serie,
  Invoice,
  User,
  ThemeSwitcher,
  LanguageSwitcher,
  Settings,
});
const rootReducer = (state, action) => {
  // Clear all data in redux store to initial.
  if(action.type === actions.LOGOUT_SUCCESS)
    state = undefined;
  return appReducer(state, action);
};
export default rootReducer;
